module.exports = __webpack_public_path__ + "static/media/DSC_6297.cab89908.jpg";